import type { ReactNode } from 'react'

import { F0Box } from '@factorialco/f0-react'

type BaseTagProps = {
  left?: ReactNode
  text?: string
  right?: ReactNode
  className?: string
  hideLabel?: boolean
  additionalAccessibleText?: string
}

export const BaseTag = ({
  left,
  text,
  right,
  className,
  hideLabel,
  additionalAccessibleText,
}: BaseTagProps) => {
  return (
    <F0Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="xs"
      width="fit"
      maxWidth="full"
    >
      {/* Designer spec: 24px height, 8px horizontal padding, 2px vertical (label line-height 20) */}
      {/* eslint-disable-next-line factorial/no-raw-html -- Exact tag dimensions (h-6, px-1.5, py-0.5) not available as F0 tokens */}
      <div
        className={[
          'inline-flex h-6 max-w-full items-center gap-1 rounded-full border border-solid border-f1-border-secondary px-2 py-0.5',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...(additionalAccessibleText && {
          'aria-label': additionalAccessibleText,
        })}
      >
        {left}
        {!!text && !hideLabel && (
          // eslint-disable-next-line factorial/no-raw-html -- Match F0 BaseTag: text-base (16px) + font-medium; F0 doesn't expose this combo via variants
          <span className="min-w-0 max-w-full truncate text-base font-medium text-f1-foreground">
            {text}
          </span>
        )}
        {right}
      </div>
    </F0Box>
  )
}
